import Banner2 from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Banner2.png";

function App() {
  return (
    <div className="LP-banner2">
      <img src={Banner2} alt="Banner" />
    </div>
  );
}

export default App;
